import { EMPTY,Observable,of,OperatorFunction,switchMap } from "rxjs";

export function addedObjects<T extends {}>():OperatorFunction<Iterable<T>,T>{
	return (input:Observable<Iterable<T>>):Observable<T>=>{
		return new Observable<T>(subscriber=>{
			let prev=new WeakSet<T>();
			return input.subscribe({
				next: objects=>{
					objects??=[];
					const cur=new WeakSet<T>();
					for(const v of objects){
						cur.add(v);
						if(!prev.has(v))
							subscriber.next(v);
					}
					prev=cur;
				},
				complete: ()=>subscriber.complete(),
				error: r=>subscriber.error(r),
			});
		});
	};
}

export function addedAfterObjects<T extends {}>():OperatorFunction<Iterable<T>,T>{
	return (input:Observable<Iterable<T>>):Observable<T>=>{
		return new Observable<T>(subscriber=>{
			let prev=new WeakSet<T>();
			let index=0;
			return input.subscribe({
				next: objects=>{
					objects??=[];
					const cur=new WeakSet<T>();
					for(const v of objects){
						cur.add(v);
						if(index>0 && !prev.has(v))
							subscriber.next(v);
					}
					prev=cur;
					index+=1;
				},
				complete: ()=>subscriber.complete(),
				error: r=>subscriber.error(r),
			});
		});
	};
}

export function deletedObjects<T extends {}>():OperatorFunction<Iterable<T>,T>{
	return (input:Observable<Iterable<T>>):Observable<T>=>{
		return new Observable<T>(subscriber=>{
			let prev=new Set<T>();
			return input.subscribe({
				next: objects=>{
					objects??=[];
					const cur=new Set<T>(objects);
					for(const item of prev){
						if(!cur.has(item))
							subscriber.next(item);
					}
					prev=cur;
				},
				complete: ()=>subscriber.complete(),
				error: r=>subscriber.error(r),
			});
		});
	};
}
